export function boardCaptureTags(defaultTags: string[], boardColumns: string[], column: string | null): string[] {
  const remaining = defaultTags.filter(tag => !boardColumns.includes(tag) && tag !== column);
  return column ? [column, ...remaining] : remaining;
}

export function nextBoardTaskPosition(positions: number[]): number {
  return positions.length ? Math.max(...positions) + 1 : Date.now();
}
